import { Observable } from 'rxjs'
import { CheckDuplicateItemCodeTypeModel, ProductItemTypeModel } from '../models/product-item.model'
import { BaseService } from '../services/base.service'

export abstract class ProductItemRepository extends BaseService {
	abstract GetProductItemByProductId(params: { id: number }): Observable<ProductItemTypeModel[]>
	abstract DeleteProductItem(params: { itemCode: string; productId: number }): Observable<void>
	abstract CheckDuplicateItemCode(params: { itemCode: string }): Observable<CheckDuplicateItemCodeTypeModel>
	abstract PostProductItem(params: { model: ProductItemTypeModel }): Observable<boolean>
}
